<template>
  <b-table 
    :class="['gk-table gk-table--responsive gk-table--striped gk-table--hover']"
    @row-clicked="rowClicked"
    :items="suggestedItems" 
    :fields="tableFields"
    thead-class="d-none"
    primary-key="id" 
    :tbody-tr-class="rowClass" 
  >
    <template #cell(invoice_date)="data">
        <span class="transaction-date">{{ data.value | formatDate }}</span>
    </template>

    <template #cell(number)="data">
      <span v-if="data.item.credited_invoice" class="">{{ data.value }} {{ $gettext('credited') }}</span>
      <span v-else class="">
        <span v-if="data.item.correction" class="">{{ data.item.correction.name }}</span>
        <span v-else class="">{{ data.value }}</span>
      </span>
    </template>

    <template #cell(recipient_customer)="data">
        <span class="transaction-description">{{ data.value.name }}</span>
    </template>

    <template #cell(total_amount)="data">
        <div class="text-right">€ {{ data.value | formatNumber }}</div>
    </template>
  </b-table>
</template>

<script>
import GekkoButton from "@/components/GekkoButton"
export default {
  name: "BankSuggestedCostTable",
  components: {
    GekkoButton,
  },
  props: {
    suggestedItems: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      tableFields: [
        { key: 'invoice_date', tdClass: 'col-date width-125' },
        { key: 'number', tdClass: '' },
        { key: 'recipient_customer', tdClass: 'col-description d-md-table-cell ellipsis' },
        { key: 'total_amount', tdClass: 'col-amount' }
      ]
    }
  },
  created () {
  },
  methods: {
    rowClicked (item) {
      this.$emit('row-clicked', item);
    },
    rowClass (item) {
      if(item && item.type) return 'transaction-row-' + item.type
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
